import { ChangeEvent } from 'react';
import { AppState } from 'src/AppState/AppState';
import { action, computed } from 'mobx';
import { DateTime } from 'src_common/utils/time/time';
import { MarketUpdateBodyType } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventActionsState/EventActionsState';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export class MarketSettingsState {
    public constructor(
        private readonly appState: AppState,
        private readonly marketId: MarketId
    ) {}

    @computed public get marketModel(): MarketModel | null {
        return this.marketId.getModel();
    }

    @computed public get suspendTime(): string | null {
        return this.marketModel?.getData().suspendTime ?? null;
    }
    @computed public get autoTakeDownValue(): boolean {
        return this.marketModel?.getData().autoTakeDown ?? false;
    }
    @computed public get suspendTimeValue(): Date | null {
        if (this.suspendTime !== null) {
            return new Date(this.suspendTime);
        }

        return null;
    }

    @action public onMarketNameSave = async (marketName: string): Promise<void> => {
        await this.appState.eventStateActions.saveMarketChanges(this.marketId, { name: marketName });
    };

    @action public onUpdateMarket = async (data: MarketUpdateBodyType): Promise<void> => {
        await this.appState.eventStateActions.saveMarketChanges(this.marketId, data);
    };

    @action public onSuspendTimeChange = async (date: Date | [Date, Date] | null): Promise<void> => {
        if (date === null) {
            const update = this.onUpdateMarket({ suspendTime: null, autoTakeDown: false });
            await update;
            return;
        }

        if (Array.isArray(date)) {
            console.error('onSuspendTimeChange: Incorrect value Array', date);
        } else {
            const time = DateTime.from(date.toString());
            const update = this.onUpdateMarket({
                suspendTime: time?.toISOString(),
            });
            await update;
        }
    };

    @action public onChangeAutoTakeDown = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
        const update = this.onUpdateMarket({ autoTakeDown: event.target.checked });
        await update;
    };

    @action public onForecastOfferedChange = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
        await this.appState.eventStateActions.saveMarketChanges(this.marketId, {
            forecastsOffered: event.target.checked,
        });
    };

    @action public onTricastOfferedChange = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
        await this.appState.eventStateActions.saveMarketChanges(this.marketId, {
            tricastsOffered: event.target.checked,
        });
    };
}
